import script from "./TutorialModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TutorialModal.vue?vue&type=script&setup=true&lang=ts"

import "./TutorialModal.vue?vue&type=style&index=0&id=29664f76&lang=css"

const __exports__ = script;

export default __exports__